export const DAIL_TITLE = "DAIL - the Database of AI Litigation";

export const DAIL_DESCRIPTION = `
This database presents information about ongoing and completed litigation involving
artificial intelligence, including machine learning. It covers cases from complaint
forward – as soon as we learn of them – whether or not they generate published
decisions. It is intended to be broad in scope, covering everything from algorithms
used in hiring and credit and criminal sentencing decisions to liability for accidents
involving autonomous vehicles. It also includes some cases concerning statistical
analysis and data protection that may not directly involve artificial intelligence,
but that are of particular relevance to AI projects. It includes cases addressing
whether AIs can be authors of works protected by copyright law, or inventors of
inventions protected by patent law, but it does not include litigation concerning
patents that may involve artificial intelligence or machine learning.
`;

export const LITIGATION_RECS_TITLE = "Litigation Recommendations or Suggestions";

export const LITIGATION_RECS_DESCRIPTION = `
If you know of AI litigation that you don’t see documented in the 
database, or if you have other suggestions, please let us know.
`;

export const CREDITS_RESEARCH_WRITING = `
Research and writing: GW Law students Jenna Fattah, Xiaonan (Caroline) Qu, 
Beatriz Beserra, Andrew Ware, Allie Schiele, Junhao Chen, Sydney Huppert, 
Zoe Kim, Molly Brown, Jenny Tavares, Rachel Lobel, and Victoria Neal, and 
Prof. Robert Brauneis. Implementation of the database on the Caspio platform: 
GW students Sean Zhao, Aneri Girishbhai Patel, Ji Wang, and Sydney Huppert, 
and Prof. Robert Brauneis.
`;

export const CREDITS_TRAILS = `
This database is based on work supported in part 
by the Institute for Trustworthy AI in Law and Society (TRAILS), which is 
supported by the National Science Foundation under Award No. 2229885. Any 
opinions, findings, and conclusions or recommendations expressed in this 
database are those of the author(s) and do not necessarily reflect the 
views of the National Science Foundation.
`;

export const DETAILS_PAGE_DESCRIPTION = `
This page presents details about 
one of the cases in the GW Law ETI AI Litigation Database. In addition to 
summaries of the case and its significance, the page includes various facts 
about the case; cites and/or links to the case docket(s); cites and/or links
to significant documents generated in the case; and links to significant
secondary sources regarding the case. You can return to the main database page here.
`;